import { ActionRequestType, ActionRequestStatus } from '@billing/validation';
import { Group, Stack, Badge, Text } from '@mantine/core';
import { User, Provider } from 'interfaces';
import { formatDateOnly } from 'utils/dateUtils';
import { Chain } from './ViewClaimActionsModal';

export const ChainCardHeader = ({
  chain,
  typeLabel,
  typeColor,
  statusColor,
}: {
  chain: Chain;
  typeLabel: string;
  typeColor: Record<ActionRequestType, string>;
  statusColor: Record<ActionRequestStatus, string>;
}) => {
  const type = chain.root.type;
  const latestStatus = chain.latestRequest.status;

  const formatName = (user?: Partial<User> | Partial<Provider>) => {
    if (!user) return '';
    const firstName = user.firstName || '';
    const lastName = user.lastName || '';
    return `${firstName} ${lastName}`.trim();
  };

  return (
    <Group justify="space-between" align="flex-start" wrap="nowrap">
      <Stack gap={4}>
        <Group gap={8}>
          <Badge color={typeColor[type]} variant="light">
            {typeLabel}
          </Badge>

          <Badge color={statusColor[latestStatus]} variant="light">
            {latestStatus}
          </Badge>
        </Group>

        <Text fw={800} size="lg" lineClamp={1} data-testid="chain-card-title">
          {type === ActionRequestType.SUPPORTING_DOCUMENTS
            ? 'Supporting Documents'
            : 'Information'}
        </Text>
        <Text size="xs" c="dimmed" data-testid="chain-card-subtitle">
          {`Requested by ${formatName(
            chain.root.requestedByUser as Partial<User>
          )} • Started ${formatDateOnly(chain.root.createdAt.toString(), {
            fallback: 'N/A',
          })}`}
        </Text>
      </Stack>
    </Group>
  );
};
